module.exports = SharedDependencies.ServiceTitan.Anvil2['@local/application'];